// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1649":"3055166f","5402":"6fa336f5","8829":"7fce6fe6"}[chunkId] + ".chunk.css";
};